module.exports = require("react-router-sitemap");


//////////////////
// WEBPACK FOOTER
// external "react-router-sitemap"
// module id = 8
// module chunks = 0